import React, { useContext } from "react";
import ModalsContext from "common/ModalsContext";
import Modal from "common/Modal";

const About = () => {
  const { closeModal } = useContext(ModalsContext);

  return (
    <Modal
      title="About"
      superIcon="info"
      onClose={() => closeModal()}
      closeLabel="OK"
      applyLabel={null}
      content={() => (
        <div>
          <p>
            The Bequant Node (BQN) is an intelligent network platform that
            processes IP packets to provide advanced traffic management
            capabilities. It has a management interface for node administration
            and one or several pairs of network interfaces to receive and send
            the user traffic being processed.
          </p>
          <h5>User Interface</h5>
          <p>
            Contextual help can be obtained by placing the mouse over an
            interactive element (to get a hint about the element function).
          </p>
          <p>
            In general, most windows show a set of icons on the top right corner
            of the window that provide specific functionality in that page:
          </p>
          <p>
            <i className="material-icons valign-icon">help_outline</i> Launch a help
            window that provides more complete description of the page. Note
            that Help windows may be moved by clicking the title area and
            dragging to a new position.
          </p>
          <p>
            <i className="material-icons valign-icon">refresh</i> Refresh the page
            content.
          </p>
          <p>
            <i className="material-icons valign-icon">more_vert</i> Show a menu with
            more options specific for that page.
          </p>

          <p>
            The BQN has also a command line interface (CLI) accessible via SSH
            to carry out advanced tasks. The users and passwords are the same as
            those of the GUI interface. More information is available in the{" "}
            <i>BQN User Guide</i>.
          </p>
        </div>
      )}
    />
  );
};

export default About;
